import {
    Dropdown,
    DROPDOWN_TYPE_CONDITION_BASE,
    DROPDOWN_TYPE_CONDITION_OPERATOR,
    DROPDOWN_TYPE_METRIC
} from "./Dropdow";
import {CONDITION_VALUE} from "../../pages/SingleCampaign";
import {HiOutlineTrash} from "react-icons/hi";
import TextInput from "./TextInput";

export const ConditionBuilder = ({condition, includeDeleteButton, onDelete, onInputChange, missingValue, setSelected}) => {
    return (
        <div className="flex flex-row w-full justify-between items-center gap-3">
            <div className="flex flex-row flex-wrap items-center gap-3">
                <Dropdown initialValue={condition.transactionBase} id={condition.id} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_CONDITION_BASE}/>
                <Dropdown initialValue={condition.transactionOperator} id={condition.id} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_CONDITION_OPERATOR}/>
                <div className="w-28">
                    <TextInput
                        id="conditionBuilderInput"
                        type="number"
                        placeholder="Value"
                        error={missingValue === condition.id ? "Required" : undefined}
                        value={condition.inputValue}
                        onChange={(event) => onInputChange(condition.id, CONDITION_VALUE, event.target.value)}
                    />
                </div>
                <Dropdown initialValue={condition.valueMetric} id={condition.id} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_METRIC}/>
            </div>
            {includeDeleteButton ? (
                <button
                    onClick={onDelete}
                    type="button"
                    className="inline-flex items-center justify-center w-10 h-10 rounded-full text-signature-coral hover:bg-surface-soft transition-colors"
                    aria-label="Delete condition"
                >
                    <HiOutlineTrash className="w-5 h-5" />
                </button>
            ) : null}
        </div>
    );
}
